module.exports = __webpack_public_path__ + "static/media/rightarrCircleBlue.9f915909.svg";